"use client";

import { Toast, ToastContainer } from "@/ui";
import useToastStore, { dismiss } from "@lib/toast/toastStore";

// Renders whatever's currently in the @/ui-backed toast store (see
// lib/toast/toast.js). Mount once per page tree that fires these toasts —
// the store is a global singleton, so nested children can push into it
// without needing this host passed down as a prop.
export default function ToastHost() {
  const toasts = useToastStore((state) => state.toasts);

  if (toasts.length === 0) return null;

  return (
    <ToastContainer position="top-center">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          title={toast.title}
          description={toast.description}
          variant={toast.variant}
          duration={toast.duration}
          onClose={() => dismiss(toast.id)}
        />
      ))}
    </ToastContainer>
  );
}
